import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight, Instagram, Facebook } from "lucide-react";
import { company, services, socials } from "@/data/content";
import { BrandLogo } from "@/components/site/BrandLogo";

const iconMap = { instagram: Instagram, facebook: Facebook };

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-surface border-t border-border">
    <div className="max-w-container mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <img src="/brand/tfs-logo-white.png" alt="Total Facilities Services" className="h-16 w-auto" />
          <p className="mt-6 text-slatetxt max-w-sm leading-relaxed">
            Nationwide facilities management for commercial properties, residential developments, managing agents and construction sites.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <a href={`tel:${company.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 text-slatetxt hover:text-white transition-colors">
              <Phone size={16} className="text-brand-light" /> {company.phone}
            </a>
            <a href={`mailto:${company.email}`} className="flex items-center gap-3 text-slatetxt hover:text-white transition-colors">
              <Mail size={16} className="text-brand-light" /> {company.email}
            </a>
            <div className="flex items-center gap-3 text-slatetxt">
              <MapPin size={16} className="text-brand-light" /> {company.address}
            </div>
          </div>
          <div className="mt-6 flex items-center gap-3">
            {socials.map((s) => {
              const Icon = iconMap[s.icon];
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`social-${s.icon}`}
                  className="h-10 w-10 flex items-center justify-center border border-border text-slatetxt hover:text-white hover:border-brand hover:bg-brand transition-colors duration-300"
                >
                  <Icon size={18} />
                </a>
              );
            })}
          </div>
        </div>

        <div className="md:col-span-3 md:col-start-6">
          <div className="text-xs uppercase tracking-[0.2em] text-slatetxt mb-5">Services</div>
          <ul className="space-y-3">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="text-sm text-white/80 hover:text-brand-light transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-slatetxt mb-5">Company</div>
          <ul className="space-y-3">
            {[
              ["About Us", "/about"],
              ["Sectors We Support", "/sectors"],
              ["Accreditations", "/accreditations"],
              ["Contact Us", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-sm text-white/80 hover:text-brand-light transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
          <Link to="/quote" data-testid="footer-quote-button" className="mt-8 inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white text-sm font-semibold px-5 py-3 transition-colors">
            Request a Quote <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slatetxt">
        <div>© {new Date().getFullYear()} Total Facilities Services Ltd. {company.reg}. All rights reserved.</div>
        <div>{company.coverage}</div>
      </div>
    </div>
  </footer>
);
